import { computed } from "vue";
export function useColorable(props) {
  const colorClass = computed(() => {
    if (props.color && !props.color.startsWith("#") && !props.color.startsWith("rgb")) {
      let colorName = props.color.split(" ")[0];
      switch (colorName) {
        case "danger":
          colorName = "error";
          break;
      }
      return colorName;
    }
    return null;
  });
  const colorModifierClass = computed(() => {
    if (props.color && !props.color.startsWith("#") && !props.color.startsWith("rgb")) {
      return props.color.split(" ").slice(1).join(" ");
    }
    return null;
  });
  const colorHex = computed(() => {
    if (props.color && (props.color.startsWith("#") || props.color.startsWith("rgb"))) {
      return props.color.split(" ")[0];
    }
    return null;
  });
  return {
    colorClass,
    colorModifierClass,
    colorHex
  };
}
